module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAXBAMAAAAFJllaAAAAMFBMVEUAAAD/aZb/aY/6aZH7aY/8aZD9aY/9aZD7aY/8aY/8aY/8aY/9aY/8aY/8aY/8aY/wq9I5AAAAD3RSTlMAESIzRFVmd4iZqrvM3e5GKvWZAAAAo0lEQVQY043QsQnCUBSF4RMMiti8VquHrQoPJ3AEJ5BskhHUCRwhkAUCzmAfEFKnFBKT3yIxeVh5igNfc+EerUrGpNLNI42U+8b92Cj2WUkL309JiXfOSdFs9DW0qsz2y0KxFQ+dO9ZmgxVcwhygjaYlVtC4JcA9yMAKeOnUV2fSIHm7OYPbY2An+Wjqw6T7szf0KwzmX2c+W6Od70LSfj3G6AN1QRMMLjOD0QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/email-reg.png
// module id = 672
// module chunks = 0